import { useCallback } from 'react'
import { useSignOut } from '@/shared/hooks/api/auth'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { AuthLayout } from '@/features/auth/auth-layout'

export function ViewOnlyAccessNotReady() {
  const { t } = useTranslation('auth')
  const { mutate: signOut, isPending: isSigningOut } = useSignOut()

  const handleSignOut = useCallback(() => {
    signOut()
  }, [signOut])

  return (
    <AuthLayout>
      <Card className='gap-4'>
        <CardHeader>
          <CardTitle className='text-lg tracking-tight'>
            {t('viewOnlyAccessNotReady.title')}
          </CardTitle>
          <CardDescription>
            {t('viewOnlyAccessNotReady.description')}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button
            type='button'
            variant='outline'
            disabled={isSigningOut}
            onClick={handleSignOut}
          >
            {t('viewOnlyAccessNotReady.signOut')}
          </Button>
        </CardContent>
      </Card>
    </AuthLayout>
  )
}
